import { FC } from "react";
import "../../../styles/Home/Benefits/Benefits.css"
import { BenefitItem } from "./BenefitItem";

const Benefits: FC = () => {
    return (
        <div className="container-fluid bg-benefits px-5 container-vertical-padding sora">
            <h1 className="fw-bold">Kenapa <span className="text-orange-1 arch-underline">Harus</span> Pakai Wooblazz CRM?</h1>
            <div className="row mt-5 pb-md-5">
                <div className="col-12 col-md-4">
                    <BenefitItem benefit="benefit-1" title="Meningkatkan janji temu & closing" />
                </div>
                <div className="col-12 col-md-4">
                    <BenefitItem benefit="benefit-2" title="CRM dengan Integrasi Chat Whatsapp" />
                </div>
                <div className="col-12 col-md-4">
                    <BenefitItem benefit="benefit-3" title="Lebih objektif dalam menilai kinerja tim sales" />
                </div>
            </div>
            <div className="row my-md-5">
                <div className="col-12 col-md-6">
                    <BenefitItem benefit="benefit-4" title="UI/UX yang sederhana dan mudah dipahami" />
                </div>
                <div className="col-12 col-md-6">
                    <BenefitItem benefit="benefit-5" title="CRM berbasis web, dapat diakses dari semua perangkat " />
                </div>
            </div>
        </div>
    )
}

export { Benefits };